import { render, staticRenderFns } from "./clearing-schema.vue?vue&type=template&id=c25bc95a"
import script from "./clearing-schema.vue?vue&type=script&lang=js"
export * from "./clearing-schema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports